import { JupiterTheme, MockHook } from '@jupiterone/jupiter-web-toolkit';
import { createStyles, makeStyles } from '@material-ui/styles';
import {
  Avatar,
  IconButton,
  ListItem,
  ListItemAvatar,
  ListItemSecondaryAction,
  ListItemText,
} from '@material-ui/core';
import {
  Settings as SettingsIcon,
  UserPlus as UserPlusIcon,
  Users as UsersIcon,
} from 'react-feather';
import React from 'react';
import useGroupListItemLogic, {
  GroupListItemComponentProps,
} from './useGroupListItemLogic';

const useStyles = makeStyles((theme: JupiterTheme) => {
  return createStyles({
    listItem: {
      paddingLeft: 0,
      paddingRight: 0,
      cursor: 'pointer',
    },
    groupAvatar: {
      background: 'rgba(0, 0, 0, 0.6)',
      border: 'none',
      color: theme.palette.primary.contrastText,
      width: 48,
      height: 48,
    },
    primaryInvitation: {
      color: theme.palette.coolGrey[50],
      fontSize: 16,
      textTransform: 'none',
    },
    secondaryInvitation: {
      color: theme.palette.coolGrey[300],
      fontSize: 14,
    },
    listActionIcon: {
      color: theme.palette.primary.contrastText,
      '&:hover, &:focus': {
        background: theme.palette.primary.main,
      },
      '&:last-child': {
        marginRight: -theme.spacing(1.5),
      },
    },
  });
});

export const GroupListItemComponent = ({
  itemName,
  onAddMemberToGroup,
  onClickSettings,
  onSelectItem,
}: GroupListItemComponentProps) => {
  const classes = useStyles();

  return (
    <ListItem className={classes.listItem} ContainerComponent="div">
      <ListItemAvatar>
        <Avatar className={classes.groupAvatar}>
          <UsersIcon />
        </Avatar>
      </ListItemAvatar>
      <ListItemText
        disableTypography={false}
        classes={{
          primary: classes.primaryInvitation,
          secondary: classes.secondaryInvitation,
        }}
        onClick={onSelectItem}
        primary={itemName}
        style={{ cursor: 'pointer' }}
      />
      <ListItemSecondaryAction>
        <IconButton
          className={classes.listActionIcon}
          aria-label="Add Member"
          onClick={onAddMemberToGroup}
        >
          <UserPlusIcon />
        </IconButton>
        <IconButton
          className={classes.listActionIcon}
          aria-label="Settings"
          onClick={onClickSettings}
        >
          <SettingsIcon />
        </IconButton>
      </ListItemSecondaryAction>
    </ListItem>
  );
};

export default MockHook.withHookHoc(
  GroupListItemComponent,
  useGroupListItemLogic
);
